import { useState } from 'react'
import { Upload } from 'lucide-react'
import { toast } from 'sonner'
import { useTranslation } from '@kostbar/i18n'
import { usePublishBundle } from '../hooks/use-publish-bundle'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Spinner } from '@/components/ui/spinner'
import { useRestaurants } from '@/features/products/hooks/use-restaurants'

export function PublishBundleForm() {
  const { t: tBundles } = useTranslation('bundles')
  const [restaurantId, setRestaurantId] = useState<string>('')

  const { data: restaurantsData } = useRestaurants()
  const publishMutation = usePublishBundle()

  const handlePublish = () => {
    if (!restaurantId) {
      toast.error(tBundles('publish.missingRestaurant'))
      return
    }

    publishMutation.mutate(parseInt(restaurantId))
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{tBundles('publish.title')}</CardTitle>
        <CardDescription>{tBundles('publish.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="restaurant">
              {tBundles('publish.restaurantLabel')}
            </Label>
            <Select value={restaurantId} onValueChange={setRestaurantId}>
              <SelectTrigger id="restaurant">
                <SelectValue
                  placeholder={tBundles('publish.restaurantPlaceholder')}
                />
              </SelectTrigger>
              <SelectContent>
                {restaurantsData?.items.map((restaurant) => (
                  <SelectItem
                    key={restaurant.id}
                    value={restaurant.id.toString()}
                  >
                    {restaurant.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <Button
            onClick={handlePublish}
            disabled={publishMutation.isPending || !restaurantId}
          >
            {publishMutation.isPending && <Spinner className="w-4 h-4 mr-2" />}
            <Upload className="w-4 h-4 mr-2" />
            {tBundles('publish.submit')}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
